/** Knowledge / guides screen copy — kept out of main locale files for LOC. */
export const knowledgeUiEn = {
  knowledgeIntro:
    'Guides power the Help assistant. Keep them short, factual, and easy to approve.',
  knowledgeFlowPromote: 'Promote or write',
  knowledgeFlowApprove: 'Approve drafts',
  knowledgeFlowVerify: 'Verify with search',
  knowledgeTabReview: 'Review',
  knowledgeTabSearch: 'Search',
  knowledgeTabLibrary: 'Library',
  knowledgeTabAdd: 'Add',
  knowledgeStatPending: 'Pending',
  knowledgeStatPublished: 'Published',
  knowledgeSearchSection: 'Try a search',
  knowledgeSearchHint: 'Same library the Help chat uses — caps, cutoffs, plays, house rules.',
  knowledgeSearchEmpty: 'Ask a question to preview what users would get.',
  knowledgeSearchResult: 'Assistant preview',
  knowledgePendingSection: 'Needs your approval',
  knowledgePendingHint: 'Drafts from tickets. Approve to publish into the searchable library.',
  knowledgePendingEmpty: 'No drafts waiting. From Tickets, resolve one and tap “Promote to knowledge”.',
  knowledgeApprove: 'Approve & publish',
  knowledgeApproved: 'Guide published',
  knowledgePublishedSection: 'Published guides',
  knowledgePublishedEmpty: 'Nothing published yet. Approve a draft or add a guide.',
  knowledgeAddSection: 'Add a guide',
  knowledgeAddHint: 'Write a short, factual guide. It becomes searchable as soon as you publish it.',
  knowledgeFormRequired: 'Add a title and content before publishing.',
  knowledgeSearchRequired: 'Type a question to search.',
  knowledgeChunks: '{count} sections',
  knowledgeScopeHouse: 'This house',
  knowledgeScopePlatform: 'Platform',
  knowledgeTypeUpload: 'Manual',
  knowledgeTypeResolution: 'From ticket',
  knowledgeTypeRepo: 'Built-in',
  knowledgeTypeDraw: 'Draw result',
  knowledgeTypeOther: 'Guide',
} as const;

export const knowledgeUiEs = {
  knowledgeIntro:
    'Las guías alimentan al asistente de Ayuda. Manténlas breves, factuales y fáciles de aprobar.',
  knowledgeFlowPromote: 'Promover o escribir',
  knowledgeFlowApprove: 'Aprobar borradores',
  knowledgeFlowVerify: 'Verificar con búsqueda',
  knowledgeTabReview: 'Revisar',
  knowledgeTabSearch: 'Buscar',
  knowledgeTabLibrary: 'Biblioteca',
  knowledgeTabAdd: 'Agregar',
  knowledgeStatPending: 'Pendientes',
  knowledgeStatPublished: 'Publicadas',
  knowledgeSearchSection: 'Probar una búsqueda',
  knowledgeSearchHint: 'La misma biblioteca del chat de Ayuda — topes, cierres, jugadas, reglas.',
  knowledgeSearchEmpty: 'Haz una pregunta para ver la respuesta que recibiría un usuario.',
  knowledgeSearchResult: 'Vista previa del asistente',
  knowledgePendingSection: 'Pendiente de aprobación',
  knowledgePendingHint: 'Borradores desde tickets. Apruébalos para publicarlos en la biblioteca.',
  knowledgePendingEmpty: 'No hay borradores. En Tickets, resuelve uno y toca “Promover a conocimiento”.',
  knowledgeApprove: 'Aprobar y publicar',
  knowledgeApproved: 'Guía publicada',
  knowledgePublishedSection: 'Guías publicadas',
  knowledgePublishedEmpty: 'Aún no hay guías. Aprueba un borrador o agrega una.',
  knowledgeAddSection: 'Agregar una guía',
  knowledgeAddHint: 'Escribe una guía breve y factual. Será buscable en cuanto la publiques.',
  knowledgeFormRequired: 'Agrega título y contenido antes de publicar.',
  knowledgeSearchRequired: 'Escribe una pregunta para buscar.',
  knowledgeChunks: '{count} secciones',
  knowledgeScopeHouse: 'Esta casa',
  knowledgeScopePlatform: 'Plataforma',
  knowledgeTypeUpload: 'Manual',
  knowledgeTypeResolution: 'Desde ticket',
  knowledgeTypeRepo: 'Integrada',
  knowledgeTypeDraw: 'Resultado de sorteo',
  knowledgeTypeOther: 'Guía',
} as const;
